import { render, staticRenderFns } from "./widget-filter.vue?vue&type=template&id=52b0af02&scoped=true&"
import script from "./widget-filter.vue?vue&type=script&lang=js&"
export * from "./widget-filter.vue?vue&type=script&lang=js&"
import style0 from "./widget-filter.vue?vue&type=style&index=0&id=52b0af02&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0af02",
  null
  
)

export default component.exports